module.exports = (h, data, i18n) => {
    return h(
        'div',
        {
            class: {
                "inbenta-bot__pdf": true
            },
            style: {
                padding: "20px"
            }
        },
        [
            h(
                'h1',
                {
                    class: {
                        "inbenta-bot__pdf__title": true
                    },
                    style: {
                        "font-family": "Arial",
                        "font-size": "16px",
                        "color": "#3d3f43",
                        "margin-bottom": "15px"
                    }
                },
                [
                    data.ticketId,
                ]
            ),
            data.history.map(entry => {
                if (['messages:new', 'chats:join', 'chats:close', 'chats:create', 'chats:leave'].indexOf(entry.event) > -1) {
                    if (entry.event === 'chats:create') {
                        return h('div', {
                            class: {
                                "body__start-chat": true
                            },
                            style: {
                                "padding": "10px",
                                "color": "#3d3f43",
                                "font-size": "13px",
                                "font-family": "Arial",
                                "font-style": "italic",
                                "background-color": "#EFF1F4",
                                "text-align": "center",
                                "margin": "25px 0 15px",
                                "border-radius": "5px"
                            }
                        }, [
                            i18n.t('chatStarted', { date: i18n.d(new Date(entry.created*1000), 'long') })
                        ]);
                    }
                    else {
                        let element = null;
                        if (entry.event === 'messages:new') {
                            element = h('div', {
                                class: {
                                    "body__messages__message": true,
                                }
                            }, [
                                h('div', {
                                    class: {
                                        "message__label": true,
                                    },
                                    style: {
                                        "font-family": "Arial",
                                        "font-size": "12px",
                                        "color": "#3d3f43",
                                        "font-weight": "bold",
                                        "padding-bottom": "3px"
                                    }
                                }, [
                                    (entry.data.sender.nickname || entry.data.sender.name) + ":"
                                ]),
                                h('div', {
                                    class: {
                                        "message__label": true,
                                    },
                                    style: {
                                        "font-family": "Arial",
                                        "font-size": "12px",
                                        "color": "#3d3f43",
                                        "font-weight": "bold",
                                        "padding-bottom": "3px"
                                    },
                                    domProps: {
                                        innerHTML: entry.data.message.message
                                    }
                                })
                            ]);
                        } else if(entry.event ==='chats:join') {
                            element = h('div', {
                                class: {
                                    "body__messages__message": true,
                                    "body__messages__message--system": true
                                }
                            }, [
                                h('i', {
                                    style: {
                                        "font-family": "Arial",
                                        "font-size": "13px",
                                        "color": "#8C8D8F"
                                    }
                                }, [
                                    i18n.t('chatJoin', { name: entry.data.user.nickname || entry.data.user.name })
                                ])
                            ]);
                        }  else if(entry.event ==='chats:leave') {
                            element = h('div', {
                                class: {
                                    "body__messages__message": true,
                                    "body__messages__message--system": true
                                }
                            }, [
                                h('i', {
                                    style: {
                                        "font-family": "Arial",
                                        "font-size": "13px",
                                        "color": "#8C8D8F"
                                    }
                                }, [
                                    i18n.t('chatLeave', { name: entry.data.user.nickname || entry.data.user.name })
                                ])
                            ]);
                        }  else if(entry.event ==='chats:close') {
                            element = h('div', {
                                class: {
                                    "body__messages__message": true,
                                    "body__messages__message--system": true
                                }
                            }, [
                                h('i', {
                                    style: {
                                        "font-family": "Arial",
                                        "font-size": "13px",
                                        "color": "#8C8D8F"
                                    }
                                }, [
                                    i18n.t('chatClosed')
                                ])
                            ]);
                        }
                        return h('div', {
                            class: {
                                "body__messages": true
                            },
                            style: {
                                "padding": "14px 0",
                                "border-bottom": "1px solid #EFF1F4"
                            }
                        }, [
                            // Show time
                            h('div', {
                                class: {
                                    "body__messages__date": true
                                },
                                style: {
                                    "color": "#8C8D8F",
                                    "font-size": "12px",
                                    "font-family": "Arial",
                                    "padding-bottom": "3px"
                                }
                            }, [
                                i18n.d(new Date(entry.created*1000), 'short')
                            ]),
                            element
                        ])
                    }
                }
            })
        ]
    );
}


// WEBPACK FOOTER //
// ./conversationTranscript/defaultTemplate.js